import { Box, Divider, Grid, Typography } from '@mui/material'
import { DashboardChart } from './dashboard-chart'
import { ITenderDashboardData } from 'types/tender/tenderDashboard'
import { useTranslation } from 'react-i18next'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'

type Props = {
  dashboardData: ITenderDashboardData
}

export const DashboardChartCalendar = ({ dashboardData }: Props) => {
  const { t } = useTranslation()
  return (
    <Box sx={{ marginTop: '70px' }}>
      <Grid container justifyContent="center" gap={'100px'}>
        <Grid item xs={5}>
          <Typography sx={{ fontWeight: 600 }}>
            {t('ongoing-contests-status')}
          </Typography>
          <Divider flexItem sx={{ margin: '10px 0' }} />
          <Box
            sx={{
              padding: '30px',
              background: '#fff',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '400px',
            }}
          >
            <DashboardChart dashboardData={dashboardData} />
          </Box>
        </Grid>
        <Grid item xs={5}>
          <Typography sx={{ fontWeight: 600 }}>{t('calendar')}</Typography>
          <Divider flexItem sx={{ margin: '10px 0' }} />
          <Box
            sx={{
              background: '#fff',
              borderRadius: '4px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '400px',
            }}
          >
            <DateCalendar />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
